export default "__VITE_ASSET__8EaGQOsh__"